let sayduckAPI;

window.addEventListener('sayduck.api-ready', (event) => {
  sayduckAPI = event.detail.instance;
  const configurations = sayduckAPI.configurator.getConfigurations();
  configurations.forEach((configuration, index) => {
    configuration.children.forEach(child => {
      let customInput;
      if (child.name === 'No Cushion') {
        customInput = document.querySelector(`.product__selectors--sayduck [data-sayduck-label="${configuration.label}"] .radio__button .radio__input[data-sayduck-value*=${JSON.stringify(child.name.split(':').join('').replace(/\s+/g, '').toLowerCase())}]`);
      } else {
        customInput = document.querySelector(`[data-sayduck-label="${configuration.label}"] .radio__button .radio__input[data-sayduck-value*=${JSON.stringify(child.name.split(':').join('').replace(/\s+/g, '').toLowerCase())}]`);
      }
      
      if (customInput) {
        customInput.dataset.sayduckUuid = child.uuid;
      }
    });
  });
  const sayduckOptionsContainer = document.querySelector('.product__selectors--sayduck');
  const optionsContainer = document.querySelector('.product__selectors:not(.product__selectors--sayduck)');
  const addToCartButton = document.querySelector('.btn--submit');
  const productForm = document.querySelector('form.product__form');
  const filters = document.querySelectorAll('.custom-option__filters');

  if (filters) {
    filters.forEach(filter => {

      const filtersObject = {};
      const filterGroups = filter.querySelectorAll('div');
      filterGroups.forEach(filterGroup => {
        const group = filterGroup.dataset.group;
        if (!filtersObject.hasOwnProperty(group)) {
          filtersObject[group] = "";
        }
      });

      filter.addEventListener('change', e => {
        const el = e.target;
        const parentContainer = el.closest('.custom-option');
        const filterVal = el.value;
        const group = el.dataset.group;
    
        if (filterVal === "all") {
          filtersObject[group] = "";
          const filterString = Object.keys(filtersObject).reduce((previousValue, currentValue) => {
            return previousValue + filtersObject[currentValue];
          }, '');
    
          if (filterString === "") {
            parentContainer.querySelectorAll(`.radio__button--custom`).forEach(element => {
              element.style.display = 'block';
            });
          } else {
            parentContainer.querySelectorAll(`.radio__button--custom[data-filter*="${filterString}"]`).forEach(element => {
              element.style.display = 'block';
            });
        
            parentContainer.querySelectorAll(`.radio__button--custom:not([data-filter*="${filterString}"])`).forEach(element => {
              element.style.display = 'none';
            }); 
          }
        } else {
          filtersObject[group] = filterVal;
          const filterString = Object.keys(filtersObject).reduce((previousValue, currentValue) => {
            return previousValue + filtersObject[currentValue];
          }, '');
  
          parentContainer.querySelectorAll(`.radio__button--custom[data-filter*="${filterString}"]`).forEach(element => {
            element.style.display = 'block';
          });
      
          parentContainer.querySelectorAll(`.radio__button--custom:not([data-filter*="${filterString}"])`).forEach(element => {
            element.style.display = 'none';
          });
        }
      });
    })
  }

  function addToCartClickEvent(e) {
    e.preventDefault();
    e.stopPropagation();

    const scenePhoto = sayduckAPI.scene.requestScreenshot({ format: 'jpeg', keepPosition: false, horizontalAngle: -35, verticalAngle: 8, width: 320, height: 320 });
    scenePhoto.then(async (value) => {
      const thumbnailInput = document.querySelector('#thumbnail-property');

      if (thumbnailInput) {
        thumbnailInput.value = value.dataUrl;
      } else {
        productForm.insertAdjacentHTML("afterbegin", `<input id="thumbnail-property" type="hidden" name="properties[_thumbnail]" value="${value.dataUrl}" />`);
      }

      addToCartButton.removeEventListener("click", addToCartClickEvent, false);
      addToCartButton.click();
      addToCartButton.addEventListener('click', addToCartClickEvent, false);
    });
  }

  addToCartButton.addEventListener('click', addToCartClickEvent, false);

  const customSkuInput = document.querySelector('#custom-sku');

  sayduckOptionsContainer.addEventListener('click', e => {

    const el = e.target;

    if (el.dataset.sayduckUuid) {
      if (el.dataset.optionReference) {
        optionsContainer.querySelector(`input[value="${el.dataset.optionReference}"]`).nextElementSibling.click();
      }

      const dataSku = el.dataset.sku;

      if (dataSku) {
        const customSkuInputValue = customSkuInput.value;
        const customSkuInputValueArray = customSkuInputValue.split('.');
        customSkuInputValueArray.splice((customSkuInputValueArray.length - 1 - parseInt(el.dataset.skuIndex)), 1, dataSku);
        const newCustomSkuInputValue = customSkuInputValueArray.join('.');
        customSkuInput.value = newCustomSkuInputValue;

        const groupLegend = el.closest('.custom-option');
        groupLegend.querySelector('.radio__legend__selected-option-label').innerHTML = ` - <strong>${el.value}</strong>`;
      }

      const wrapperContainer = el.closest('.selector-wrapper--sayduck');
      const propertyInput = wrapperContainer.querySelector('input[type="hidden"]');
      propertyInput.value = el.value;

      sayduckAPI.configurator.setActiveByUuid(el.dataset.sayduckUuid);
    }
  }, false);

  optionsContainer.addEventListener('click', e => {

    const el = e.target;

    if (el.dataset.sayduckUuid) {
      sayduckAPI.configurator.setActiveByUuid(el.dataset.sayduckUuid);
    }
  }, false);

  sayduckOptionsContainer.querySelectorAll('.selector-wrapper--sayduck').forEach(el => {
    el.querySelector('.radio__legend__selected-option-label').innerHTML = ` - <strong>${el.querySelector('.radio__input:checked').value}</strong>`;

    if (el.querySelector('.radio__input:checked').dataset.optionReference) {
      optionsContainer.querySelector(`input[value="${el.querySelector('.radio__input:checked').dataset.optionReference}"]`).nextElementSibling.click();
    }

    const sayDuckUUID = el.querySelector('.radio__input:checked').dataset.sayduckUuid;

    if (sayDuckUUID) {
      sayduckAPI.configurator.setActiveByUuid(sayDuckUUID);
    }
  });

  optionsContainer.querySelectorAll('.selector-wrapper').forEach(el => {

    const sayDuckUUID = el.querySelector('.radio__input:checked').dataset.sayduckUuid;

    if (sayDuckUUID) {
      sayduckAPI.configurator.setActiveByUuid(sayDuckUUID);
    }
  });

  const htmlElement = document.querySelector('html');

  if (!htmlElement.classList.contains('supports-touch')) {
    const customOptions = document.querySelectorAll('.radio__button--custom');

    customOptions.forEach(option => {
      option.addEventListener('mouseenter', e => {

        const el = e.target;
        const parent = el.closest('.custom-option');
        const optionTooltip = parent.querySelector('.option-tooltip');
        const optionTooltipImage = optionTooltip.querySelector('img');
        const optionTooltipTitle = optionTooltip.querySelector('p');
        const optionTitle = el.querySelector('.radio__input').value;
        const optionTooltipImageSrc = el.querySelector('.swatch--custom').dataset.tooltipSrc;

        optionTooltipImage.src = optionTooltipImageSrc;
        optionTooltipImage.alt = `${optionTitle} fabric`;
        optionTooltipTitle.innerHTML = optionTitle;
        optionTooltip.style.display = 'block';
      }, false);

      option.addEventListener('mouseleave', e => {
        const el = e.target;
        const parent = el.closest('.custom-option');
        const optionTooltip = parent.querySelector('.option-tooltip');

        optionTooltip.style.display = 'none';
      }, false);
    });
  }

});
